import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Sidebar from "./components/Sidebar";
import Login from "./pages/Login";
import TeamWeek from "./pages/TeamWeek";
import Executive from "./pages/Executive";
import Dynamics from "./pages/Dynamics";
import ClientHeatmap from "./pages/ClientHeatmap";
import ManagerDashboard from "./pages/ManagerDashboard";
import VacationCalendar from "./pages/VacationCalendar";
import TasksBoard from "./pages/TasksBoard";
import ClientDirectory from "./pages/ClientDirectory";
import ClientReminderCalendar from "./pages/ClientReminderCalendar";
import ClientPayments from "./pages/ClientPayments";
import KonturPayments from "./pages/KonturPayments";
import FinanceOverview from "./pages/finance/FinanceOverview";
import FinanceAccounts from "./pages/finance/FinanceAccounts";
import FinancePayments from "./pages/finance/FinancePayments";
import FinancePayroll from "./pages/finance/FinancePayroll";
import FinanceIncome from "./pages/finance/FinanceIncome";
import Settings from "./pages/Settings";
import Users from "./pages/Users";
import Employees from "./pages/Employees";
import Vpn from "./pages/Vpn";
import VpnAdmin from "./pages/VpnAdmin";
import Regulations from "./pages/Regulations";
import RegulationDoc from "./pages/RegulationDoc";
import { PERM } from "./permissions";
import "./App.css";
import "./tasks.css";

function AppLayout({ children }) {
  return (
    <div className="app">
      <a className="skip-link" href="#main-content">
        К содержимому
      </a>
      <Sidebar />
      <main id="main-content" className="main-content" tabIndex={-1}>
        {children}
      </main>
    </div>
  );
}

function gated(permission, page) {
  return (
    <ProtectedRoute requiredPermission={permission}>
      <AppLayout>{page}</AppLayout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/vpn" element={<Vpn />} />
          <Route path="/vpn-admin" element={gated(PERM.VPN_ADMIN, <VpnAdmin />)} />
          <Route path="/" element={gated(PERM.SURVEYS_VIEW, <TeamWeek />)} />
          <Route path="/executive" element={gated(PERM.EXECUTIVE_VIEW, <Executive />)} />
          <Route path="/dynamics" element={gated(PERM.SURVEYS_VIEW, <Dynamics />)} />
          <Route path="/clients" element={gated(PERM.SURVEYS_VIEW, <ClientHeatmap />)} />
          <Route path="/manager" element={gated(PERM.MANAGER_REPORTS_VIEW, <ManagerDashboard />)} />
          <Route path="/vacations" element={gated(PERM.VACATIONS_ACCESS, <VacationCalendar />)} />
          <Route path="/tasks" element={gated(PERM.TASKS_ACCESS, <TasksBoard />)} />
          <Route path="/client-directory" element={gated(PERM.CLIENTS_ACCESS, <ClientDirectory />)} />
          <Route path="/client-reminders" element={gated(PERM.CLIENTS_ACCESS, <ClientReminderCalendar />)} />
          <Route path="/client-payments" element={gated(PERM.CLIENTS_FEE, <ClientPayments />)} />
          <Route path="/kontur-payments" element={gated(PERM.KONTUR_ACCESS, <KonturPayments />)} />
          <Route path="/finance" element={gated(PERM.FINANCE_ACCESS, <FinanceOverview />)} />
          <Route path="/finance/accounts" element={gated(PERM.FINANCE_ACCESS, <FinanceAccounts />)} />
          <Route path="/finance/payments" element={gated(PERM.FINANCE_ACCESS, <FinancePayments />)} />
          <Route path="/finance/payroll" element={gated(PERM.FINANCE_ACCESS, <FinancePayroll />)} />
          <Route path="/finance/income" element={gated(PERM.FINANCE_ACCESS, <FinanceIncome />)} />
          <Route path="/settings" element={gated(PERM.SETTINGS_ACCESS, <Settings />)} />
          <Route path="/users" element={gated(PERM.USERS_MANAGE, <Users />)} />
          <Route path="/employees" element={gated(PERM.EMPLOYEES_MANAGE, <Employees />)} />
          <Route path="/regulations" element={gated(null, <Regulations />)} />
          <Route path="/regulations/:id" element={gated(null, <RegulationDoc />)} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
